export class BriefingDashboardCount {
    id = 0;
    briefingCount = 0;
    briefingTypeCount = 0;
    briefingSubTypeCount = 0;
    briefingchecklistCount = 0;
    checklistCount = 0;
}
